__turbopack_context__.v({
  "actions": "section-module__FR-Ita__actions",
  "brand": "section-module__FR-Ita__brand",
  "dark": "section-module__FR-Ita__dark",
  "grey-light": "section-module__FR-Ita__grey-light",
  "inner": "section-module__FR-Ita__inner",
  "subTitle": "section-module__FR-Ita__subTitle",
  "title": "section-module__FR-Ita__title",
  "wrapper": "section-module__FR-Ita__wrapper",
});
